import React from "react";
import { useSelector } from "react-redux";
import { Row, Col } from "reactstrap";

function GridHeader() {
  const { isModalPage } = useSelector((state) => ({
    isModalPage: state.Layout.isModalPage,
  }));

  if (isModalPage) return <></>;

  return (
    <Row>
      <Col>
        <h4 className="text-color-azul1 fw-semibold mb-0">
          Validar Nota Fiscal
        </h4>
      </Col>
    </Row>
  );
}

export default GridHeader;
